import { useState, useEffect } from "react";
import api from '../api';
import * as XLSX from "xlsx";
import '../styles/cursosTable.scss';

const CursosTable = () => {
    const [cursos, setCursos] = useState([]);
    const [filteredCursos, setFilteredCursos] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const cursosPorPagina = 10;

    useEffect(() => {
        const fetchCursos = async () => {
            try {
                const response = await api.get('/cursos');
                setCursos(response.data);
                setFilteredCursos(response.data);
            } catch (error) {
                console.error('Erro ao buscar cursos:', error);
            }
        };

        fetchCursos();
    }, []);

    useEffect(() => {
        const results = cursos.filter(curso =>
            curso['CURSO OFERTADO'].toLowerCase().includes(searchTerm.toLowerCase()) ||
            curso['CÓDIGO POLO'].toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredCursos(results);
        setCurrentPage(1); // Resetar a página para 1 ao filtrar
    }, [searchTerm, cursos]);

    const downloadExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredCursos);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Cursos');


        // Formata a data e hora atual
        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', ''); // Substitui / por - e remove a vírgula

        const fileName = `Cursos—${formattedDate}.xlsx`; // Define o nome do arquivo

        // Faz o download do arquivo Excel
        XLSX.writeFile(workbook, fileName);
    };

    // Cálculo da paginação
    const indexOfLastCurso = currentPage * cursosPorPagina;
    const indexOfFirstCurso = indexOfLastCurso - cursosPorPagina;
    const currentCursos = filteredCursos.slice(indexOfFirstCurso, indexOfLastCurso);
    const totalPages = Math.ceil(filteredCursos.length / cursosPorPagina);

    // Lógica para exibir os números das páginas
    const getPaginationButtons = () => {
        const buttons = [];
        const maxButtonsToShow = 5;

        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Cursos Por Polo</h1>
            <input
                type="text"
                placeholder="Filtrar por Curso ou Codigo Polo"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
            />
            <button onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>POLO</th>
                        <th>CÓDIGO POLO</th>
                        <th>NOME DO POLO</th>
                        <th>CURSO OFERTADO</th>
                        <th>STATUS DA OFERTA</th>
                    </tr>
                </thead>
                <tbody>
                    {currentCursos.map((curso, index) => (
                        <tr key={index}>
                            <td>{curso.POLO}</td>
                            <td>{curso['CÓDIGO POLO']}</td>
                            <td>{curso['NOME DO POLO']}</td>
                            <td>{curso['CURSO OFERTADO']}</td>
                            <td>{curso['STATUS DA OFERTA']}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."} >
                        {page}
                    </button>
                ))}
            </div>
        </div>
    );
}

export default CursosTable;
